export default class StoryVariables { }

StoryVariables.WEEK_NUMBER = "week_number";
StoryVariables.STORY_TIME = "storyTime";
// TODO: REDESIGN THE CHAPTER TO NOT BE DEPENDANT ON A SPECIFIC VARIABLE
StoryVariables.CHAPTER = "chapter";
StoryVariables.PATH = "path";
StoryVariables.SCORE = "score";